// extracted by mini-css-extract-plugin
export default {"section":"Stats_section__h7uFV","container":"Stats_container__1w+Jh","item":"Stats_item__hLiH+","icon":"Stats_icon__wSYFN","num":"Stats_num__OFOC8","label":"Stats_label__41Sut"};